import { defineMessages } from 'react-intl';
import { messages as arrayFieldMessages } from '../ArrayField/translations';

export const messages = {
  ...arrayFieldMessages,
};

export default defineMessages(messages);
